export default __webpack_public_path__ + "static/DettolSansWeb-ExtraBold-4b8a7dd6c15b0e84691fcd9242845bde.woff2";